import { PaymentMethodEnum, PaymentStatusEnum } from 'src/Constants/enums'

import type { Curator } from './users'
import type { CampaignPlatformTypeEnum } from './campaigns'

export interface Payment {
  id: number
  transaction_id: string
  paid_amount: string
  created_at: string
  balance_used: string
  status: PaymentStatusEnum
  campaigns_full_price: string
  type: PaymentMethodEnum
  confirmed_at: string
  charged_back_amount: string | null
  charged_back_at: string | null
  updated_at: string
  user_id: number
}

export interface PaypalPayment {
  amount: number
}

export interface StripePayment {
  amount: number
  campaignId: number
  campaignValue: number
  startDate: string | Date
  type: CampaignPlatformTypeEnum
  usedBalance: number
  couponValue?: string
  cancelUrl: string
  successUrl: string
}

export enum PayoutStatus {
  Paid = 'paid',
}

export type Payout = {
  id: number
  amount: number
  date: string | Date
  status: PayoutStatus
  transfer_id: number | null
  curator_id: number
  curator_complaints: number
  curator_payouts: number
  Curator: Curator
  total_payouts: number
  Recipient: {
    is_checking_needed: boolean
    country: string
  }
}

export enum TransactionTypeEnum {
  USED = 'used',
  RECEIVED = 'received',
  CHARGEBACK = 'chargeback',
  PAYMENT = 'payment',
  COUPON_BONUS = 'bonus_credit_coupon',
  BONUS = 'bonus',
  REFERRAL_BONUS = 'referral_bonus',
  INVITED_BONUS = 'invited_bonus',
  SUBSCRIPTION = 'subscription',
  CASHBACK = 'cashback',
  SUBSCRIPTION_PAYMENT_FAILED = 'subscription_payment_failed',
  QUICK_CHECKOUT_BONUS_FUTURE = 'quick_checkout_bonus_future_payment',
  QUICK_CHECKOUT_BONUS_CURRENT = 'quick_checkout_bonus_current_payment',
}

export interface Recipient {
  accountHolderName: string
  currency: string
  type: string
  details: {
    address: RecipientAddress
  }
}

export interface RecipientAddress {
  country: string
  countryCode: string
  firstLine: string
  postCode: string
  city: string
  state: string
}

export interface TransferwiseRequirement {
  type: string
  title: string
  usageInfo: string
  fields: Array<TransferwiseRequirementField>
}

export interface TransferwiseRequirementGroup {
  example: string
  key: string
  name: string
  refreshRequirementsOnChange: boolean
  validationRegexp: string | null
  required: boolean
  valuesAllowed: TransferwiseRequirementValuesAllowed[] | null
  type: InputType
}

export interface TransferwiseRequirementValuesAllowed {
  key: string
  name: string
}

export interface TransferwiseRequirementField {
  name: string
  group: TransferwiseRequirementGroup[]
  valuesAllowed: TransferwiseRequirementValuesAllowed[]
}

export interface MobileBalanceItems {
  id?: number | string
  date: string | Date
  type: string
  description: { title: string; description: string | undefined }
  amount: { amount: number; type: string }
}

export interface CreatorTransaction {
  id: number
  type: string
  payoutStatus: string
  createdAt: string
  description: string
  amount: number
}

export interface WiseCurrency {
  code: string
  hasBankDetails: boolean
  payInAllowed: boolean
  sampleBankDetails: null
}

type InputType = 'radio' | 'select' | 'date' | 'text'
